const CONFIG = {
  sanity: {
    projectId: '1iafdz2j',
    dataset: 'production',
    token:
      'skch4Tk6DQFCzVf2LhdEU8kLF04pivaXmCQI58JlWVEeZQ1bhKFXL6pFYRq14bf9XOqcXCcFjoEFSJbq81esF4XK9NDCORtJJCFVm2LyNmP9yufZ6m8Uk5uutwwYUhFvdWVwYOzGaHVAisO6l46c1T5HjoOQbWqPdeZktkpkLxADUFPWopX7',
  },
}
export default CONFIG
